import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

function CardEntrega(props) {
    const nomeRecebedorLabel = props.pedidoColetadoTransportadora
        ? 'Nome do recebedor da transportadora:'
        : 'Nome do recebedor:';

    const BannerTransportadora = () => (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            width: '100%',
            marginBottom: '30px',
            padding: '16px 20px',
            borderLeft: '4px solid #0b6fbd',
            borderRadius: '4px',
            background: '#f4f8ff',
            boxShadow: '0 0 0 1px #d9e6fb inset'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '48px',
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                color: '#0b6fbd',
                background: '#e4eefc'
            }}>
                <Icon name='truck' size='large' />
            </div>
            <div>
                <h3 style={{ margin: '0 0 6px', color: '#0b3d78' }}>Seu pedido foi coletado pela transportadora!</h3>
                <p style={{ margin: 0, color: '#1f2937' }}>Seu pedido sera transportado ate o destino final e, em breve, sera entregue no endereco do destinatario.</p>
            </div>
        </div>
    );

    return (
        <>
            {props.mobile ? (
                <div style={{ display: 'flex', flex: 1, width: '100%', flexDirection: 'column', marginTop: '30px', marginBottom: '50px', borderTop: '2px solid #e9e9e9', borderBottom: '2px solid #e9e9e9', padding: '20px 0px' }}>
                    {props.pedidoColetadoTransportadora && <BannerTransportadora />}

                    <h3>Dados da entrega:</h3>

                    <div style={{ display: 'flex', flex: 1, width: '100%', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>

                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <h4>{nomeRecebedorLabel}</h4>
                            <p style={{ textAlign: 'center' }}>{props.dados.recebedor}</p>
                        </div>


                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <h4>Doc. do recebedor:</h4>
                            <p>{props.dados.docrecebedor}</p>
                        </div>

                    </div>

                    <div style={{ display: 'flex', flex: 1, width: '100%', justifyContent: 'space-between', alignItems: 'center', marginTop: '30px' }}>

                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Button onClick={props.handleAbrirModal} primary>Ver detalhes</Button>
                        </div>

                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                        </div>


                    </div>


                </div>
            ) : (
                <div style={{ display: 'flex', flex: 1, width: '100%', flexDirection: 'column', marginTop: '30px', marginBottom: '50px', borderTop: '2px solid #e9e9e9', borderBottom: '2px solid #e9e9e9', padding: '20px 0px' }}>
                    {props.pedidoColetadoTransportadora && <BannerTransportadora />}

                    <h3>Dados da entrega:</h3>

                    <div style={{ display: 'flex', flex: 1, width: '100%', justifyContent: 'space-evenly', alignItems: 'center', marginTop: '10px' }}>

                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <h4>{nomeRecebedorLabel}</h4>
                            <p> {props.dados.recebedor}</p>
                        </div>

                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <h4>Documento do recebedor:</h4>
                            <p>{props.dados.docrecebedor}</p>
                        </div>

                        <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>

                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 10 }} >
                                <h4>Detalhes da entrega:</h4>
                            </div>

                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Button onClick={props.handleAbrirModal} primary>Ver detalhes</Button>
                            </div>
                        </div>


                    </div>


                </div>
            )}

        </>
    );
}

export default CardEntrega;

